export const HAS_USED_CRM = 'has_used_crm';
export const HAS_USED_HUBSPOT = 'has_used_hubspot';
export const SURVEY_CONFIG_STATUS = {
  FETCHING: 'fetching',
  FETCHED: 'fetched',
  NOT_FETCHED: 'not_fetched'
};